import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=0c3ebcee&scoped=true&"
import script from "./Note.vue?vue&type=script&lang=js&"
export * from "./Note.vue?vue&type=script&lang=js&"
import style0 from "./Note.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Note.vue?vue&type=style&index=1&id=0c3ebcee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ebcee",
  null
  
)

export default component.exports